var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "M34 67.484c18.502 0 33.5-14.999 33.5-33.5 0-18.502-14.998-33.5-33.5-33.5C15.499.484.5 15.482.5 33.984c0 18.501 14.999 33.5 33.5 33.5",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "m33.03 46.412 20.1-20.1a3.366 3.366 0 0 0 0-4.757 3.364 3.364 0 0 0-4.757 0L30.65 39.31 19.63 28.255a3.364 3.364 0 0 0-4.757 4.757l13.4 13.4a3.35 3.35 0 0 0 4.757 0"
  })));
};
export default SvgCheckCircle;